import { Injectable, signal } from '@angular/core';

export interface QuickRateState {
  origin: string;
  destination: string;
  weight: string;
  loadType: string;
}

@Injectable({
  providedIn: 'root',
})
export class QuoteStateService {
  readonly origin = signal('');
  readonly destination = signal('');
  readonly weight = signal('');
  readonly loadType = signal('');

  setQuickRate(state: QuickRateState): void {
    this.origin.set(state.origin);
    this.destination.set(state.destination);
    this.weight.set(state.weight);
    this.loadType.set(state.loadType);
  }
}
